import produce from 'immer'
import React, { FC, useEffect, useState } from 'react'
import { Col, Form, Modal, Row } from 'react-bootstrap'
import { FilterOptionModel } from '../../models/utils/filterOption'
import { status } from '../../utils/metaData'
import FilterButton from '../common/filterButton/FilterButton'
import Select from 'react-select'
import DatePicker from 'react-datepicker'

export interface FileAllocationFiltersProps {
  filterData: FilterOptionModel[]
  onFilter: any
}

const IncidentTypesFilters: FC<FileAllocationFiltersProps> = ({
  filterData,
  onFilter,
}) => {
  const [filters, setFilters] = useState(filterData)
  const [show, setShow] = useState(false)

  useEffect(() => {
    setFilters(filterData)
  }, [show])
  return (
    <>
      <FilterButton
        onClick={() => {
          setShow(true)
        }}
      />
      <Modal
        size="lg"
        show={show}
        onHide={() => {
          setShow(false)
        }}
        aria-labelledby="example-modal-sizes-title-sm"
        dialogClassName="custom-modal-layout"
        contentClassName="custom-modal-content"
      >
        <Modal.Header
          closeButton
          closeVariant="white"
          className="custom-modal-header"
        >
          <Modal.Title id="example-modal-sizes-title-sm">{`Filter`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="p-4">
            {filters.length > 0 && (
              <Form>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formProgrameType"
                >
                  <Col sm="1" className="align-self-center">
                    <Form.Check
                      type="checkbox"
                      checked={filters[0].selected}
                      onChange={(e) => {
                        const newFilters = produce(
                          filters,
                          (draft: FilterOptionModel[]) => {
                            draft[0].selected = e.target.checked
                          }
                        )
                        setFilters(newFilters)
                      }}
                    />
                  </Col>
                  <Form.Label column sm="5">
                    {`Incident Type`}
                  </Form.Label>
                  <Col sm="6">
                    <Form.Control
                      type="text"
                      value={filters[0].value}
                      disabled={!filters[0].selected}
                      onChange={(e) => {
                        const newFilters = produce(
                          filters,
                          (draft: FilterOptionModel[]) => {
                            draft[0].value = e.target.value
                          }
                        )
                        setFilters(newFilters)
                      }}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3" controlId="effectiveDate">
                  <Col sm="1" className="align-self-center">
                    <Form.Check
                      type="checkbox"
                      checked={filters[2].selected}
                      onChange={(e) => {
                        const newFilters = produce(
                          filters,
                          (draft: FilterOptionModel[]) => {
                            draft[2].selected = e.target.checked
                          }
                        )
                        setFilters(newFilters)
                      }}
                    />
                  </Col>
                  <Form.Label column sm="5">
                    {`Effective Date`}
                  </Form.Label>
                  <Col sm="6">
                    <DatePicker
                      className={'form-control'}
                      selected={
                        filters[2].value != null
                          ? new Date(filters[2].value * 1000)
                          : null
                      }
                      onSelect={(date: Date) => {
                        const newFilters = produce(
                          filters,
                          (draft: FilterOptionModel[]) => {
                            draft[2].value = new Date(date).getTime() / 1000
                          }
                        )
                        setFilters(newFilters)
                      }}
                      onChange={(date: Date) => {
                        const newFilters = produce(
                          filters,
                          (draft: FilterOptionModel[]) => {
                            draft[2].value = new Date(date).getTime() / 1000
                          }
                        )
                        setFilters(newFilters)
                      }}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3" controlId="status">
                  <Col sm="1" className="align-self-center">
                    <Form.Check
                      type="checkbox"
                      checked={filters[3].selected}
                      onChange={(e) => {
                        const newFilters = produce(
                          filters,
                          (draft: FilterOptionModel[]) => {
                            draft[3].selected = e.target.checked
                          }
                        )
                        setFilters(newFilters)
                      }}
                    />
                  </Col>
                  <Form.Label column sm="5">
                    {`Status`}
                  </Form.Label>
                  <Col sm="6">
                    <Select
                      value={filters[3].dropdownValue}
                      isDisabled={!filters[3].selected}
                      options={status}
                      onChange={(selectedOption) => {
                        const newFilters = produce(
                          filters,
                          (draft: FilterOptionModel[]) => {
                            draft[3].value = selectedOption?.value
                            draft[3].dropdownValue = selectedOption
                          }
                        )
                        setFilters(newFilters)
                      }}
                    />
                  </Col>
                </Form.Group>
              </Form>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="save-button"
            onClick={() => {
              onFilter(filters)
              setShow(false)
            }}
          >
            Filter Results
          </button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default IncidentTypesFilters
